import axios from "axios";
import { useQuery } from "@tanstack/react-query";

export const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
export const api = axios.create({ baseURL: `${BACKEND}/api` });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("ari_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const fileUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND}${u}` : u || "");

export const formatErr = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg || "").replace("Value error, ", "")).join(" ");
  return String(d);
};

export const DEFAULT_SETTINGS = {
  phone: "+91 98992 13153",
  whatsapp: "919899213153",
  email: "autocratrubber@yahoo.com",
  address: "Khasra no 6316, 175 Autocrat Rubber Industries, Huda gali, industrial area, Rajendra Park, Gurgaon Rural, Gurugram, Haryana 122006",
  map_query: "Autocrat Rubber Industries, Rajendra Park, Gurugram, Haryana 122006",
  map_link: "https://google.com/maps/place/Autocrat+Rubber+Industries/data=!4m2!3m1!1s0x0:0xc56c8753becdb9c9?sa=X&ved=1t:2428&ictx=111",
  hours: "Mon - Sat, 9:30 AM - 6:30 PM",
  company_profile_pdf: "",
  catalog_pdf: "",
  certifications: [],
};

export function useSettings() {
  const { data } = useQuery({
    queryKey: ["settings"],
    queryFn: () => api.get("/settings").then((r) => r.data),
  });
  return { ...DEFAULT_SETTINGS, ...(data || {}) };
}

export function useCategories() {
  const { data, isLoading } = useQuery({
    queryKey: ["categories"],
    queryFn: () => api.get("/categories").then((r) => r.data),
  });
  return { categories: Array.isArray(data) ? data : [], isLoading };
}

export const waLink = (num, text = "Hello Autocrat Rubber, I would like a quote for ") =>
  `https://wa.me/${String(num || "").replace(/\D/g, "")}?text=${encodeURIComponent(text)}`;

export const CLIENTS = ["Luminous", "Okaya", "Akira", "Longway", "Bos JRG", "StesaLIT"];
